import { createContext } from "react";

import { useMainLayout } from "./useMainLayout";

type MainLayoutContextType = ReturnType<typeof useMainLayout>;

export const MainLayoutContext = createContext<
  MainLayoutContextType | undefined
>(undefined);
